import { forwardRef } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

const Container = forwardRef(
  ({ isHeaderFixed = false, className = "", children }, ref) => (
    <div
      {...{ ref }}
      className={classnames(
        "flex h-dvh grow flex-col items-start justify-start overflow-y-auto",
        isHeaderFixed ? "[&>*]:px-5 [&>*]:md:px-10" : "px-5 md:px-10",
        className
      )}
    >
      {children}
    </div>
  )
);

Container.displayName = "Container";

Container.propTypes = {
  /**
   * Decides whether the `Header` component should be stickied at the top on scroll.
   */
  isHeaderFixed: PropTypes.bool,
  /**
   * Additional classes to be added to the container.
   */
  className: PropTypes.string,
};

export default Container;
